import script from "./PassingObjectsCollection.vue?vue&type=script&lang=ts&setup=true"
export * from "./PassingObjectsCollection.vue?vue&type=script&lang=ts&setup=true"

import "./PassingObjectsCollection.vue?vue&type=style&index=0&id=c3f61878&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3f61878"]])

export default __exports__